import React from "react";
import "../Health/HealthBanner.css";
import { motion } from "framer-motion";
import bgImage from "../../Assets/tech/Technologies.png";

const TechnologyBanner = () => {
  return (
    <section className="health-banner">
      {/* Animated Background Image Reveal */}
      <motion.img
        src={bgImage}
        alt="Background"
        className="bg-image"
        initial={{ scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      />
<div className="bg-overlay"></div>
      <div className="banner-content">
        {/* Left content reveal */}
        <motion.div
          className="left-content"
          initial={{ x: -80, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.div
            className="text-box"
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 1, ease: "easeOut" }}
          >
            <h2>
              Where 
              <motion.span
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7, duration: 1 }}
              > People, Purpose, <br />and Technology Connect.
              </motion.span>
            </h2>
            <p>
              At VCNR Technologies, we build technology that puts people first. From AI to automation, our solutions don't just solve problems, they make everyday lives better, smarter, and more connected. We are not just shaping the future of tech, we are making it meaningful.
            </p>

            <motion.button
              className="explore-btn1"
              onClick={() => window.open("https://vcnrtech.com/", "_blank")}
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ delay: 1, duration: 0.8 }}
            >
              Know More
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TechnologyBanner;
